
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.14 39.986V26.488h4.547l.681-5.26H29.14v-3.359c0-1.523.424-2.56 2.616-2.56l2.797-.002v-4.705c-.484-.064-2.144-.207-4.075-.207-4.031 0-6.79 2.452-6.79 6.954v3.879h-4.56v5.26h4.56v13.498H6.93A1.927 1.927 0 015 38.063V7.054c0-1.062.864-1.923 1.93-1.923h31.125c1.066 0 1.931.86 1.931 1.923v31.009a1.927 1.927 0 01-1.93 1.923H29.14z"}})])
          )
        }
      }
    